<template>
  <div>
    <h3 class="mobile-margin">Offers</h3>
    <p>
      Congrats! You verified your account. Please wait while we validate your
      identity and crunch some numbers...
    </p>
      <div class="columns is-3">
      <div class="column desktop is-one-third " :class="choice.selected == true ? 'cardiff-offer' : ''"  v-for="(choice, idx) in inputs.dealChoices" :key="'choice'+idx">
        <p class="info-chunk striped" :class="idx > 0 ? 'go-away' : ''">BEST DEAL!</p>
        <div class="inner-column">
          <h2 class="offer-title">
            ${{choice.payment}}
            <span style="font-size: 12px;">/{{choice.frequency}}</span>
          </h2>
          <div class="mobile-info">
            <div class="columns flex-no-grow">
              <div class="column vert-center is-one-third">
                <Radio class="no-border"
                  :inputField="choice.selected"
                  inputName="Deal Choice"
                  inputType="required"
                  @changed="handleChange"
                  :ref="'radio'+idx"
                  :val="choice.selected"
                  :id="choice.id"
                >
                  <a href="#" target="_blank"></a>
                </Radio>
              </div>
              <div class="column">
                <div>
                  <p class="info-chunk">Term<span>{{choice.term}} mo</span></p>
                  
                </div>
                <div>
                  <p class="info-chunk">Interest<span>{{choice.rate}}</span></p>
                  
                </div>
                <div>
                  <p class="info-chunk">Total<span>{{choice.total}}</span></p>
                  
                </div>
              </div>
            </div>
          </div>
          <div class="hide-mobile">
            <p class="info-chunk">
              Term
              <span>{{choice.term}} months</span>
            </p>
            <p class="info-chunk">
              Interest
              <span>{{choice.rate}}</span>
            </p>
            <p class="info-chunk">
              Total
              <span>{{choice.total}}</span>
            </p>
            <Radio
        :inputField="choice.selected"
        inputName="Deal Choice"
        inputType="required"
        @changed="handleChange"
        :ref="'radio'+idx"
        :val="choice.selected"
        :id="choice.id"
      >
        <a href="#" target="_blank"></a>
      </Radio>
          </div>
      
        </div>
      </div>




    </div>
    <!-- <div class="columns is-3">
      <div class="column desktop is-one-third cardiff-offer">
        <p class="info-chunk striped">BEST DEAL!</p>
        <div class="inner-column">
          <h2 class="offer-title">
            $138
            <span style="font-size: 12px;">/week</span>
          </h2>
          <div class="mobile-info">
            <div>
              <p class="info-chunk">Term</p>
              <span>6 mo</span>
            </div>
            <div>
              <p class="info-chunk">Interest</p>
              <span>0</span>
            </div>
            <div>
              <p class="info-chunk">Total</p>
              <span>0</span>
            </div>
          </div>
          <div class="hide-mobile">
            <p class="info-chunk">
              Term
              <span>6 months</span>
            </p>
            <p class="info-chunk">
              Interest
              <span>0</span>
            </p>
            <p class="info-chunk">
              Total
              <span>0</span>
            </p>
          </div>
          <Radio
            :inputField="inputs.dealChoices[0].selected"
            inputName="Deal Choice"
            inputType="required"
            @changed="handleChange"
          >
            <a href="#" target="_blank"></a>
          </Radio>
        </div>
      </div>
      <div class="column desktop is-one-third">
        <p class="info-chunk striped" style="opacity:0">BEST DEAL!</p>
        <div class="inner-column">
          <h2 class="offer-title">
            $64
            <span style="font-size: 12px;">/week</span>
          </h2>
          <div class="hide-mobile">
            <p class="info-chunk">
              Term
              <span>12 months</span>
            </p>
            <p class="info-chunk">
              Interest
              <span>0</span>
            </p>
            <p class="info-chunk">
              Total
              <span>0</span>
            </p>
          </div>
          <div class="mobile-info">
            <div>
              <p class="info-chunk">Term</p>
              <span>12 mo</span>
            </div>
            <div>
              <p class="info-chunk">Interest</p>
              <span>0</span>
            </div>
            <div>
              <p class="info-chunk">Total</p>
              <span>0</span>
            </div>
          </div>
          <Radio
            :inputField="inputs.dealChoices[1].selected"
            inputName="Deal Choice"
            inputType="required"
            @changed="handleChange"
          >
            <a href="#" target="_blank"></a>
          </Radio>
        </div>
      </div>
      <div class="column desktop is-one-third">
        <p class="info-chunk striped" style="opacity:0">BEST DEAL!</p>
        <div class="inner-column">
          <h2 class="offer-title">
            $110
            <span style="font-size: 12px;">/day</span>
          </h2>
          <div class="mobile-info">
            <div>
              <p class="info-chunk">Term</p>
              <span>3 mo</span>
            </div>
            <div>
              <p class="info-chunk">Interest</p>
              <span>0</span>
            </div>
            <div>
              <p class="info-chunk">Total</p>
              <span>0</span>
            </div>
          </div>
          <div class="hide-mobile">
            <p class="info-chunk">
              Term
              <span>3 months</span>
            </p>
            <p class="info-chunk">
              Interest
              <span>0</span>
            </p>
            <p class="info-chunk">
              Total
              <span>0</span>
            </p>
          </div>
          <Radio
            :inputField="inputs.dealChoices[2].selected"
            inputName="Deal Choice"
            inputType="required"
            @changed="handleChange"
          >
            <a href="#" target="_blank"></a>
          </Radio>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import Input from "@/components/shared/Input";
import $ from "jquery";
import Radio from "@/components/shared/Radio";
export default {
  name: "Offers",
  components: {
    Radio
  },
  props: {
    customerId: String
  },
  data() {
    return {
      obj: "financials",
      inputs: {
        ts: "",
        dealChoices: [
          {
            id: 1,
            payment: 138,
            frequency: "week",
            term: 3,
            rate: 1.45,
            total: "$" + 50000,
            selected: true
          },
          {
            id: 2,
            payment: 139,
            frequency: "week",
            term: 3,
            rate: 1.45,
            total: "$" + 50000,
            selected: false
          },
          {
            id: 3,
            payment: 140,
            frequency: "week",
            term: 3,
            rate: 1.45,
            total: "$" + 50000,
            selected: false
          }
        ]
      }
    };
  },
  mounted: function() {
    var self = this;
    $.ajax({
      type: "POST",
      url: "/api/apply/determine-eligibility",
      contentType: "application/json",
      dataType: "json",
      data: JSON.stringify({ customerId: self.customerId })
    }).done(function(response) {
      console.log("Yay, done!!", response);
      if (response.status) {
        self.inputs.ts = response.status;
      }
      // self.next();
    });
    // setTimeout(this.next, 6000)
  },
  methods: {
    next() {
      this.$emit("next", this.$data);
      console.log(this.$data);
    },
    handleChange(data) {
      console.log("handle change");
      console.log("xd", data);
      this.inputs.dealChoices.forEach((choice, idx) => {
        console.log("choice", choice);
        if (choice.id == data.id) {
          choice.selected = true;
        } else {
          choice.selected = false;
        }
        // choice.selected = !choice.selected
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.desktop {
  border-radius: 5px;
  box-shadow: 1px 3px 6px 2px rgba(50, 114, 220, 0.1),
    0 1px 10px 2px rgba(0, 0, 0, 0.1);
  margin: 0.75rem;
  padding: 0;
}

.mobile-margin {
  margin-top: 10px;
}

.inner-column {
  padding: 0.75rem 1.25rem;
  vertical-align: bottom;
}
.bordered {
  border: 1px solid gray;
  border-radius: 0.25rem;
  margin: 0 0.75rem;
}
.cardiff-offer {
  background: #f0f4ff;
}
.offer-title {
  text-align:center;
  margin-bottom: 0 !important;
}

.info-chunk {
  padding-top: 0.5rem;
  font-size: 19px;
  font-weight: bold;
  margin: 0 !important;
  text-align:left;
}

.go-away{
  opacity:0;
}

.striped {
  background: #2c4ca3;
  text-align: center;
  padding: 2px;
  border-top-right-radius: 0.25rem;
  border-top-left-radius: 0.25rem;
  color: white;
  font-size: 14px;
  font-weight: bold;
}

.info-chunk span {
  float: right;
  text-align: right;
}

.padded-button {
  margin-top: 25px;
  padding: 0;
}
.mobile-info {
  display: none;
}

.flex-no-grow{
  display:flex;
  flex-grow:0;
}

.vert-center{
  display: flex;
  flex:none;
  justify-content: center;
  align-items: center;
  width:20%;
}

@media only screen and (max-width: 1024px) {
  .hide-mobile {
    display: none;
  }
  .mobile-info {
    display: inline-flex;
    width: 100%;
    text-align: center;
  }
  .mobile-info > div {
    flex-grow: 1;
    flex-shrink: 0;
    
  }

  .offer-title{
    margin: 0 0 0 69px;
    text-align:left;
  }

  div > span {
    font-size: 20px;
    font-weight: bold;
    display:inine;
  }
}
</style>
